module.exports = __webpack_public_path__ + "202408221624/img/icon_loading_24@2x.38e73352.png";